export default __webpack_public_path__ + "static/media/background.13293007.jpg";